import React, { lazy, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useRoutes, useLocation } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import LocalStorage from '../src/utils/storage';
import { clear, setTrackData } from './features/common/apiLoggerSlice';
import { trackUserApiActions, getDefaultConfig } from './apis';
import { clearTrackData, getTrackData } from './utils/apiTrackUtil';
import { RETAIL_TEAM } from './routes/constants';
import { isNonEmptyString } from './utils/checks';

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const SupplyManagementLayout = lazy(() => import('./containers/SupplyManagementLayout'))
const Login = lazy(() => import('./pages/Login'))
const SupplyManagementLogin = lazy(() => import('./pages/SupplyManagementLogin'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
// const Register = lazy(() => import('./pages/Register'))
// const Documentation = lazy(() => import('./pages/Documentation'))


initializeApp()


const token = checkAuth()
const ROLE = LocalStorage.getItem('userRole')
const TEAM = LocalStorage.getItem('team')

const POLLING_TIME = 20000

function App() {

  const {trackDataSuccess} = useSelector(state => state.apiLogger);
  const dispatch = useDispatch();
  const location = useLocation()

  useEffect(() => {
    themeChange(false)
  }, [])

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     //api call 
  //     const trackedData = getTrackData()
  //     if (trackedData?.length) {
  //       dispatch(trackUserApiActions(trackedData))
  //       clearTrackData()
  //     }
  //   }, POLLING_TIME)

  //   return () => {
  //     clearInterval(interval)

  //     // make api call and dump all data
  //     const trackedData = getTrackData()
  //     if (trackedData?.length) {
  //       dispatch(trackUserApiActions(trackedData))
  //       clearTrackData()
  //     }
  //   };
  // }, [location.pathname])

  // useEffect(() => {
  //   if (trackDataSuccess) {
  //     dispatch(clear({key: 'trackDataSuccess', value: false }));
  //   }
  // }, [trackDataSuccess])

  useEffect(() => {
    if(isNonEmptyString(ROLE)){
      dispatch(getDefaultConfig({}))
    }
  }, [])

  return (
    <>
      {/* <Router> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/supply-management/login" element={<SupplyManagementLogin />} />
          {/* <Route path="/documentation" element={<Documentation />} /> */}
          
          {/* Place new routes over this */}
          <Route path="/supplier/*" element={<Layout />} />
          <Route path="/ops/*" element={<Layout />} />
          <Route path="/warehouse/*" element={<Layout />} />
          <Route path="/supply-management/*" element={<SupplyManagementLayout />} />
          <Route path="/retail/*" element={<Layout />} />

          <Route path="*" element={<Navigate to={
            ((ROLE === 'admin' || ROLE === 'super_admin' && TEAM === 'india') && token) ? "/ops/in-house-orders" :
            ((ROLE === 'admin' || ROLE === 'super_admin' && TEAM === 'warehouse') && token) ? "/warehouse/source" :
            ((ROLE === 'admin' || ROLE === 'super_admin' && TEAM === RETAIL_TEAM) && token) ? "/retail/allocation-dashboard" :
            ((ROLE === 'vendor' || ROLE === 'internal_team') && token) ? "/supplier/my-orders" : 
            ((ROLE === 'retail_admin') && token) ? "/retail/allocation-dashboard" :
            ((ROLE === 'ops' || ROLE === 'admin' || ROLE === 'super_admin') && token) ? "/ops/all-pending-orders" : 
            (ROLE === 'ops_team' && token) ? "/supplier/qc-platform" :
            (ROLE === 'bm_team' && token) ? "/supplier/buyer-review" :
            ((ROLE === 'bm_admin' && TEAM === 'india') && token) ? "/ops/india-catalogue-management" :
            ((ROLE === 'cataloging_team' && TEAM === 'china') && token) ? "/supplier/assortments" :
            (ROLE === 'bm_admin' && token) ? "/supplier/catalogue-management" : 
            (ROLE === 'china_warehouse_team' && token) ? "/supplier/qc-platform" :
            (ROLE === 'india_qc_manager' && token) ? '/supplier/qc-platform-india' : 
            (ROLE === 'india_qc_inward_wh' && token) ? '/supplier/india-inward-platform':
            (ROLE === 'warehouse' && token) ? '/warehouse/source':
            (ROLE === 'cad' && token) ? '/ops/in-house-orders':
            (ROLE === 'finance_team' && token) ? '/supplier/finance-portal':
            "/login"} replace />}/>

        </Routes>
      {/* </Router> */}
    </>
  )
}

export default App
